import { useTranslation } from "react-i18next";
import RobinPage from "../components/core/RobinPage";
import { message, Row, Col, Form, Input, Button, Spin } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import {
  useGetMyUserQuery,
  useUpdateMyUserMutation,
} from "../graphql/generated/hooks";

function ProfileUpdate() {
  const { t, i18n } = useTranslation();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const { data: user } = useGetMyUserQuery();
  const [updateUser, { loading: updating }] = useUpdateMyUserMutation();

  const onFinish = async (values: any) => {
    await updateUser({
      variables: {
        email: values.email,
        name: values.name,
      },
    })
      .then(() => {
        messageApi.success(t("message.success.data_updated"));
        navigate(-1);
      })
      .catch((error) => {
        messageApi.error(t("message.error.data_update_failed"));
      });
  };

  return (
    <RobinPage title={t("title.edit_profile")}>
      <Row>
        {contextHolder}
        <Col span={24}>
          {user ? (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              dir={i18n.dir()}
              name="mutateProfile"
              initialValues={{
                ...user.getMyUser,
              }}
            >
              <Form.Item name="name" label="Name">
                <Input />
              </Form.Item>
              <Form.Item name="email" label="Email">
                <Input />
              </Form.Item>
              <Form.Item>
                <Button loading={updating} type="primary" htmlType="submit">
                  {t("button.save")}
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <Spin />
          )}
        </Col>
      </Row>
    </RobinPage>
  );
}

export default ProfileUpdate;
